import deepFreeze from 'deep-freeze';

export const MODEL_NAME = Object.freeze({
  SINGULAR: 'formularyEntry',
  PLURAL: 'formulary-entries',
});

export const FIELD_NAME = Object.freeze({
  ID: 'id',
  ACTIVE: 'active',
  NDC: 'ndc',
  KIOSK_ID: 'kioskId',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
});

export const SCHEMA = deepFreeze({
  title: MODEL_NAME.SINGULAR,
  type: 'object',
  properties: {
    [FIELD_NAME.ID]: {
      type: 'string',
    },
    [FIELD_NAME.KIOSK_ID]: {
      type: 'string',
    },
    [FIELD_NAME.ACTIVE]: {
      type: 'boolean',
    },
    [FIELD_NAME.NDC]: {
      type: 'string'
    },
    [FIELD_NAME.CREATED_AT]: {
      type: 'string'
    },
    [FIELD_NAME.UPDATED_AT]: {
      type: 'string'
    },
  },
});
